import { createSlice } from "@reduxjs/toolkit";

const commentSlice = createSlice({
  name: "comment",
  initialState: {
    loading: false,
    error: false,
    totalPage: 0,
    totalComment: 0,
    dataComment: [],
    dataReply: []
  },
  reducers: {
    getAll: (state) => {
      state.loading = true;
      state.error = false;
    },
    getAllSuccess: (state, action) => {
      state.loading = false;
      state.error = false;
      state.dataComment = action.payload.dataComment;
      state.dataReply = action.payload.dataReply;
      state.totalPage = action.payload.totalPage;
      state.totalComment = action.payload.totalComment
    },
    getAllFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
    create: (state) => {
      state.loading = true;
      state.error = false;
    },
    createSuccess: (state) => {
      state.loading = false;
      state.error = false;
    },
    createFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
    update: (state) => {
      state.loading = true;
      state.error = false;
    },
    updateSuccess: (state) => {
      state.loading = false;
      state.error = false;
    },
    updateFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
    block: (state) => {
      state.loading = true;
      state.error = false;
    },
    blockSuccess: (state) => {
      state.loading = false;
      state.error = false;
    },
    blockFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
    remove: (state) => {
      state.loading = true;
      state.error = false;
    },
    removeSuccess: (state) => {
      state.loading = false;
      state.error = false;
    },
    removeFailed: (state) => {
      state.loading = false;
      state.error = true;
    },
  },
});

export const commentActions = commentSlice.actions;
export default commentSlice.reducer;
